/**
 * SetupBanner — the persistent reminder Layout shows while the signed-in
 * customer's self-service tenant still has setup steps to finish
 * (needsSelfServeSetup, lib/onboarding-setup.ts) and they've navigated away
 * from `/setup`. The soft half of the blueprint-D2 gating: the wizard never
 * traps, but the unfinished state stays visible everywhere.
 *
 * A Carbon info notification (neutral, D17), with the guide link as its action.
 */

import { Link } from 'react-router-dom'
import { SETUP_BANNER, SETUP_ROUTE } from '@/lib/onboarding-setup'
import { InlineNotification } from '@/components/carbon/InlineNotification'
import { IconArrowRight } from '@/components/carbon/icons'

export default function SetupBanner() {
  return (
    <InlineNotification
      kind="info"
      title={SETUP_BANNER.headline}
      actions={
        <Link to={SETUP_ROUTE} className="inline-flex items-center gap-2 whitespace-nowrap text-link hover:text-link-hover hover:underline">
          {SETUP_BANNER.cta}
          <IconArrowRight />
        </Link>
      }
    >
      {SETUP_BANNER.body}
    </InlineNotification>
  )
}
